import {fork} from 'redux-saga/effects';

import {sagas as bank} from './bank';
import {sagas as profile} from './profile';

export function* sagas() {
  yield fork(bank);
  yield fork(profile);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/account/index.js